import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is the best eCommerce platform for my business?",
    answer: `<p>Our eCommerce web development company works with leading platforms like Shopify, WooCommerce, BigCommerce, and Magento. We'll help you choose the best fit for your business needs.</p>`,
  },
  {
    question: "How long does eCommerce solution development take?",
    answer: `<p>We start web development within 48 hours and can have your MVP ready within a week, ensuring a quick and efficient launch. For a complete website development roadmap get in touch with our experts and consult your project.</p>`,
  },
  {
    question:
      "How do you ensure that eCommerce websites are secure and protect customer information?",
    answer: ` <p>We implement advanced security measures, including SSL certificates, data encryption, and regular security audits, to protect customer information and ensure a secure shopping experience.</p>`,
  },
  {
    question:
      "Can you integrate the new eCommerce solution into my existing one?",
    answer: `<p>Yes, our eCommerce web design agency specializes in seamless integration with your current systems, including ERP and CRM tools, ensuring a cohesive and efficient workflow.</p>`,
  },
  {
    question:
      "Do you offer custom eCommerce website design and enterprise solutions?",
    answer: `<p>Absolutely. We provide tailored eCommerce web development services to meet the unique needs of your business, from startups to large enterprises.</p>`,
  },
  {
    question: "What eCommerce platforms do you work with?",
    answer: ` <p>Our team is proficient in various eCommerce platforms, including Shopify, WooCommerce, Magento, BigCommerce, and more, to provide you with the best options for your business.</p>`,
  },
  {
    question:
      "What makes your eCommerce website design and development efficient?",
    answer: ` <p>We focus on user experience, fast load times, and responsive design, combined with our expertise in SEO and analytics, to create highly efficient eCommerce websites.</p>`,
  },
  {
    question:
      "Do you offer eCommerce SEO and conversion optimization services?",
    answer: `<p>Yes, our eCommerce web development services include SEO and conversion optimization to drive organic traffic and maximize sales.</p>`,
  },
  {
    question: "Does TekRevol offer NDAs for web development projects?",
    answer: `<p>Yes, TekRevol provides Non-Disclosure Agreements (NDAs) to ensure the confidentiality and security of your sensitive information throughout the web development process.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>eCommerce Website Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
